import { message, Modal } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { deleteApplication, getApplicationsByEvent, updateApplicationRound } from "../../api/application";
import { loadState } from "../../stores/store";
import { useSettings } from "../../contexts/settingsContext";
import ApplicationTable from "../Applications/applicationsTable";

const EventApplicationsModal = ({ event, visible, onCancel }) => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const { state: settings } = useSettings();

  useEffect(() => {
    fetchApplications();
  }, [event, settings.selectedRound]);

  const fetchApplications = async () => {
    try {
      const applicationsData = await getApplicationsByEvent(event._id);
      const filteredApplications = applicationsData.filter(app => app.round === settings.selectedRound);
      setApplications(filteredApplications);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching applications by event:", error);
      setLoading(false);
    }
  };

  const handleDelete = useCallback(async (applicationId) => {
    try {
      await deleteApplication(applicationId);
      message.success('Application deleted successfully');
      fetchApplications();
    } catch (error) {
      message.error('Failed to delete application');
      console.error('Error deleting application:', error);
    }
  }, [fetchApplications]);

  const isAdmin = useMemo(() => loadState().user.role === 'admin', []);
  const handleRowClick = useCallback((index) => {
    setSelectedRow(index);
    setSelectedApplication(applications[index]);
  }, [applications]);

  const handleMoveToNextRound = useCallback(async (applicationId) => {
    try {
      await updateApplicationRound(applicationId);
      message.success('Application moved to next round');
      fetchApplications();
    } catch (error) {
      message.error('Failed to move application to next round');
      console.error('Error moving application to next round:', error);
    }
  }, [fetchApplications]);

  return (
    <Modal
      open={visible}
      loading={loading}
      onCancel={onCancel}
      title={`Applications for ${event.name} - Round ${settings.selectedRound}`}
      width={1000}
      footer={null}
    >
      <ApplicationTable
        loading={loading}
        applications={applications}
        isAdmin={isAdmin}
        onRowClick={handleRowClick}
        onDelete={handleDelete}
        onMoveToNextRound={handleMoveToNextRound}
      />
    </Modal>
  );
};

export default EventApplicationsModal;  
